import { motion, AnimatePresence, MotionNodeAnimationOptions } from "framer-motion";

type HiddenableContainerProps = {
  show: boolean,
  config?: MotionNodeAnimationOptions
} & React.HTMLAttributes<HTMLDivElement>;

export const HiddenableContainer = (props: HiddenableContainerProps) => {
  const { show, children, config = {} } = props;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          layout
          key="HiddenableContainer"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10, maxHeight: 0 }}
          transition={{ duration: 0.3 }}
          {...config}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};


